// extracted by mini-css-extract-plugin
module.exports = {"erply-settings__payment":"Payment_erply-settings__payment__RTNhi"};